import type { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverMetricAdjustmentEntity } from '../entities/DriverMetricAdjustmentEntity'
import type { DriverMetricAdjustmentFilterEntity } from '../entities/DriverMetricAdjustmentFilterEntity'
import type { SearchDriverStatus } from '@/backend/market'

export abstract class DriverMetricAdjustmentRepository {
  abstract getAdjustments(
    filters: DriverMetricAdjustmentFilterEntity
  ): Promise<PaginateEntity<DriverMetricAdjustmentEntity> | { error: true }>

  abstract getAdjustment(
    id: string
  ): Promise<DriverMetricAdjustmentEntity | { error: true }>

  abstract revokeAdjustment(
    id: string,
    reason: string
  ): Promise<DriverMetricAdjustmentEntity | { error: true }>

  abstract createAcceptanceAdjustment(data: {
    searchDriverId: string
    effectiveStatus: SearchDriverStatus
    reason: string
    idempotencyKey: string
  }): Promise<DriverMetricAdjustmentEntity | { error: true }>

  abstract createShiftAdherenceAdjustment(data: {
    driverShiftId: string
    startAt: string
    endAt: string
    reason: string
    idempotencyKey: string
  }): Promise<DriverMetricAdjustmentEntity | { error: true }>
}
